import styled from 'styled-components';

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1rem;

  section.income-expense {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 1rem;
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0 1rem 0;
 // background-color: white;
  border-radius: 12px;
`;

export const InfoCard = styled.div<{ highlight?: boolean }>`
  flex: 1;
  min-width: 220px;
  background: ${({ highlight }) =>
    highlight
      ? 'linear-gradient(135deg, #d1fae5, #10b98120)'
      : 'linear-gradient(135deg, #f3f4f6, #e5e7eb)'};
  color: ${({ highlight }) => (highlight ? '#065f46' : '#1f2937')};
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: default;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
  }

  h4 {
    font-size: 1rem;
    font-weight: 500;
    color: inherit;
    margin-bottom: 0.5rem;
  }

  span {
    font-size: 1.5rem;
    font-weight: bold;
    color: inherit;
  }

  &::after {
    content: '';
    position: absolute;
    top: -30px;
    right: -30px;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    z-index: 0;
  }
`;

export const Container = styled.div`
  padding: 0 2rem;
`;

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  padding: 12px 1rem;

  .field {
    display: flex;
    flex-direction: column;
  }

  label {
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    margin-bottom: 4px;
  }

  input[type='date'] {
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    font-size: 0.9rem;
    color: #1f2937;

    &:focus {
      outline: none;
      border-color: #4f46e5;
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
    }

    &[aria-invalid='true'] {
      border-color: #dc2626;
      box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
    }
  }

  .presets {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-basis: 100%;
    font-size: 0.8rem;
    color: #6b7280;
  }

  .status .error {
    color: #dc2626;
    font-weight: 500;
  }

  .status .loading {
    color: #4f46e5;
    font-weight: 500;
  }
`;

export const PresetButton = styled.button<{ active?: boolean }>`
  padding: 8px 16px;
  border-radius: 8px;
  border: ${({ active }) => (active ? 'none' : '1px solid #ccc')};
  background-color: ${({ active }) => (active ? '#4F46E5' : '#f3f4f6')};
  color: ${({ active }) => (active ? '#fff' : '#4B5563')};
  cursor: pointer;
  font-weight: 600;
  font-size: 0.85rem;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: ${({ active }) => (active ? '#4338ca' : '#e5e7eb')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1f2937;
`;
